export default __webpack_public_path__ + "static/8-de0648ab3d21522df3d87112e4db04bb.png";